export default __webpack_public_path__ + "static/media/bgFLOW3.484d0894.jpg";